import React, { ReactElement } from 'react';

import { Inject } from '@odinjs/odin';

import { Route } from '@philips-emr/hpms-stipulator-commons';
import TokenConstants from '@philips-emr/hpms-stipulator-commons/lib/constants/token-constants';
import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import { HpmsCustomCardApi } from '@philips-emr/hpms-stipulator-components';
import { DeckAPI, Token } from '@philips-emr/tws-components';
import { Type } from '@philips-emr/tws-constants';
import Controller, { OnAfterFetch, OnClick, OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { FetchEvent, MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';
import { AuthenticationService } from '@philips-emr/tws-core/lib/services';

import { MensagensResumoDashboardAliases as Aliases, FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import { Mensagem, MensagemStatus } from './mensagem-controller';

import './mensagens-resumo-dashboard-controller.css';

@Controller({ fragment: FragmentNames.MENSAGENS_RESUMO_DASHBOARD })
export default class MensagensResumoDashboardController extends BaseController {

  private readonly PERMISSION_MENSALIDADE = '9122_5';

  @Inject(Aliases.DECK_MENSAGENS)
  private deckMensagens: DeckAPI;

  @OnMount(Aliases.DECK_MENSAGENS)
  public onMountDeck(): void {
    const token = AuthenticationService.getJWTToken();
    const ieTipoContrato = token && token.claims[TokenConstants.IE_TIPO_CONTRATO];

    if (this.hasPermissionMensalidade() && ieTipoContrato == 'C') {
      this.deckMensagens.setLimit(7);
      this.deckMensagens.setReset(true);
    } else {
      this.deckMensagens.setLimit(3);
      this.deckMensagens.setReset(true);
    }

    this.deckMensagens.setDone(true);
  }

  @OnClick(Aliases.LINK_MOSTRAR_TODOS)
  public onClickMostrarTodos(): void {
    this.historyService.push(Route.MENSAGENS);
  }

  private hasPermissionMensalidade(): boolean {
    return StipulatorContext.isAllowedTwsFunction(this.PERMISSION_MENSALIDADE);
  }

  @OnAfterFetch(Aliases.FETCH_MENSAGENS)
  onAfterFetchMensagens(event: FetchEvent): void {
    const { hasMensalidade } = this.context.getBulkData();
    if (!hasMensalidade) {
      const limitMensagens = this.deckMensagens.getData().slice(0, 4);
      this.deckMensagens.setData(limitMensagens);
    }

    if (event.data) {
      this.deckMensagens.setDone(true);
    }
  }

  @OnMount(Aliases.HPMS_MENSAGENS)
  onMountHpmsCustomCardMensagens({ target }: MountEvent): void {
    const api = target as HpmsCustomCardApi;
    const data = api.state;
    const { ieLeitura } = data as unknown as { ieLeitura: string };
    if (ieLeitura !== MensagemStatus.SIM) {
      api.setBackground('hsl(var(--color-5))');
    }
  }

  @OnDynamicContentRender(Aliases.HPMS_MENSAGENS)
  onDynamicContentRenderCustomCardMensagens({ data, render }: RenderEvent): void {
    const { ieLeitura } = data as Mensagem;
    let leitura: ReactElement = <></>;

    if (ieLeitura !== MensagemStatus.SIM) {
      leitura = <Token type={Type.NOTICE} value={''} />;
    }

    render(() => <>
      { leitura }
    </>);
  }

}
